import React, { useContext, useState } from 'react'
import List from './List'
import { ReactComponent as SearchIcon } from '../../../../common/icons/search.svg'
import { Box, TextField, Alert } from '@mui/material'
import RadioSelect from '../../../../common/components/RadioSelect'
import { SettingsContext } from '../../../../App'

export default function AllMicroTrainingsField({ input, type, isEditing }) {
  const [search, setSearch] = useState('')
  const [{ companyLanguage }] = useContext(SettingsContext)
  const [language, setLanguage] = useState(companyLanguage)

  return (
    <Box sx={styles.container}>
      {!isEditing && (
        <Alert severity='warning' sx={{ width: '100%', mb: 2 }}>
          Attention! When switching between "Modules" and "Custom modules" tabs, selected data will be reset.
        </Alert>
      )}
      <Box width={'100%'} justifyContent={'space-between'} display={'flex'}>
        <TextField
          size='small'
          placeholder='Search'
          onChange={e => {
            setSearch(e.target.value)
          }}
          value={search}
          variant='outlined'
          InputProps={{ endAdornment: <SearchIcon /> }}
          sx={styles.textField}
        />
        {type !== 'CUSTOM' && (
          <RadioSelect
            style={{ marginRight: 20 }}
            options={[
              'Dutch',
              'English',
              'English (UK)',
              'French',
              'German',
              'Italian',
              'Polish',
              'Portuguese',
              'Russian',
              'Slovak',
              'Slovenian',
              'Spanish',
              'Ukrainian'
            ]}
            value={language}
            onSelectOption={el => {
              setLanguage(el)
            }}
          />
        )}
      </Box>
      <List input={input} search={search} language={language} type={type} isEditing={isEditing} />
    </Box>
  )
}

const styles = {
  textField: {
    width: '70%',
    '& .MuiInputBase-root': { borderRadius: '14px' }
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    rowGap: '16px',
    alignItems: 'center',
    paddingTop: '28px',
    paddingBottom: '24px'
  }
}
